import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/components/flex/center/index.ts